import { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { CheckIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { useContext } from 'react'
import { AuthContext } from '../../../Context'


const ModalMensagem = () => {

    const { states, setters } = useContext(AuthContext)


    return (
        <Transition.Root show={states.modalMsg} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={setters.setModalMsg}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative flex max-h-[90vh] w-full max-w-sm transform flex-col overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full">
                                <div className="shrink-0 px-4 pt-5 sm:px-6 sm:pt-6">
                                    {
                                        states.perigoModalMsg ? (
                                            <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
                                                <ExclamationTriangleIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
                                            </div>
                                        ) : (

                                            <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
                                                <CheckIcon className="h-6 w-6 text-green-600" aria-hidden="true" />
                                            </div>
                                        )
                                    }
                                    <div className="mt-3 text-center sm:mt-5">
                                        <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                                            {states.msgModalMsg}
                                        </Dialog.Title>
                                    </div>
                                </div>
                                <div className="min-h-0 flex-1 overflow-y-auto px-4 sm:px-6">
                                    <p className="py-2 text-center text-sm text-gray-500">
                                        {states.descModalMsg}
                                    </p>
                                </div>
                                <div className="flex shrink-0 justify-stretch gap-3 px-4 pb-4 pt-2 sm:px-6 sm:pb-6">

                                    <button
                                        type="button"
                                        className="inline-flex w-full justify-center rounded-md bg-red-400 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-400"
                                        onClick={() => setters.setModalMsg(false)}
                                    >
                                        {
                                            states.titleButtonCloseModalMsg
                                        }
                                    </button>
                                    <button
                                        type="button"
                                        className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                                        onClick={ () => states.functionModalMsg()}
                                    >
                                        {
                                            states.titleButtonModalMsg
                                        }
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}


export default ModalMensagem
